export const REPORT_ITEM_STATUS = {
  ACTIVE: 'active',
  UNAVAILABLE: 'unavailable',
}

export const POPUP_FIELD_KEY = {
  NAME: 'Name',
  REGISTRATION_NUMBER: 'REGISTRATION_NUMBER',
  REPORT_TYPE: 'Report_Type',
  NOTE: 'Note',
  PHONE: 'Phone',
  EMAIL: 'Email',
}
